var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "width": "1200px",
      "title": "Credit Historical Approval Records",
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "top": "3vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('div', {
    staticClass: "tableWrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.dataListLoading,
      expression: "dataListLoading"
    }],
    attrs: {
      "border": "",
      "data": _vm.dataList
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Handling Time",
      "width": "164px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm._f("parseTimeSecond")(scope.row.createAt)) + " ")];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Applyment Status",
      "width": "154px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm.creditStatusFormat(scope.row.creditStatus)) + " ")];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "align": "center",
      "label": "Reason"
    }
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Attachment"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return _vm._l(scope.row.attachmentUrls, function (item) {
          return _c('p', {
            key: item.url
          }, [_c('a', {
            attrs: {
              "href": item.url,
              "target": "_target"
            }
          }, [_vm._v(_vm._s(item.name))])]);
        });
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Handler"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.userInfo && scope.row.userInfo.nickname ? _c('p', [_vm._v(" " + _vm._s(scope.row.userInfo.nickname) + " ")]) : _vm._e()];
      }
    }])
  })], 1), _c('pagination', {
    attrs: {
      "current": _vm.current,
      "pageSize": _vm.pageSize,
      "totalCount": _vm.totalCount
    },
    on: {
      "size-change": _vm.sizeChangeHandle,
      "current-change": _vm.currentChangeHandle
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }